import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Icon,
  IconButton,
  Input,
} from "@chakra-ui/react";
import { IoClose } from "react-icons/io5";
import { FiAtSign } from "react-icons/fi";

export const NewsCard = ({
  title,
  actionButton,
  noteText,
  onDismiss,
  inputField,
}) => {
  return (
    <Box
      bg="white"
      borderRadius="8px"
      boxShadow="0px 2px 4px rgba(12, 0, 28, 0.04), 0px 0px 6px rgba(12, 0, 28, 0.02)"
      overflow="hidden"
    >
      <Box p={4}>
        <Flex justify="space-between" align="flex-start" gap={4}>
          <Text
            fontSize="12px"
            fontWeight="500"
            lineHeight="1.5"
            color="dark.500"
            fontFamily="Geist, sans-serif"
            flex="1"
          >
            {title}
          </Text>

          <IconButton
            icon={<Icon as={IoClose} />}
            aria-label="Dismiss"
            variant="ghost"
            size="sm"
            minW="20px"
            h="20px"
            p={0}
            color="dark.500"
            _hover={{ bg: "gray.100" }}
            onClick={onDismiss}
          />
        </Flex>

        {actionButton && (
          <Box mt={3}>
            <Button
              bg="#4C47CC"
              color="white"
              fontSize="13px"
              fontWeight="700"
              lineHeight="1.231"
              fontFamily="Geist, sans-serif"
              borderRadius="8px"
              px="8px"
              py="8px"
              h="auto"
              minH="auto"
              transition="all 0.2s"
              _hover={{
                bg: "#3A37B3",
                transform: "translateY(-1px)",
              }}
              _active={{
                transform: "translateY(0px)",
              }}
              onClick={actionButton.onClick}
            >
              {actionButton.text}
            </Button>
          </Box>
        )}

        {noteText && (
          <Box mt={3} bg="#F6F5F7" borderRadius="4px" p={3}>
            <Text
              fontSize="11px"
              fontWeight="500"
              lineHeight="1.455"
              color="granite"
              fontFamily="Geist, sans-serif"
            >
              {noteText}
            </Text>
          </Box>
        )}

        {inputField && (
          <Flex
            mt={3}
            borderRadius="12px"
            border="1px solid #D0CCD5"
            bg="white"
            align="center"
            px={3}
            py={2}
            h="43px"
          >
            <Icon as={FiAtSign} w="20px" h="20px" color="gray.400" mr={2} />
            <Input
              placeholder={inputField.placeholder || "pete@email.com"}
              fontSize="14px"
              fontWeight="500"
              lineHeight="1.429"
              color="dark.500"
              fontFamily="Geist, sans-serif"
              border="none"
              _focus={{ boxShadow: "none" }}
              p={0}
            />
          </Flex>
        )}
      </Box>
    </Box>
  );
};
